module.exports = __webpack_public_path__ + "img/hotspot.da5a2b60.png";